export const environment = {
  production: true,
  bankIdUrl: 'https://test.studioe.akiru.se/service',
  apiUrl: 'https://test.studioe.akiru.se/api',
  service: 'fotografera'
}
